// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import XngZone from "@pace/App/Components/Common/XngZone";
import React, { FC } from "react";

export interface MyAccountListPagesLayoutStyles {
    container?: InjectableCss;
    titleContainer?: InjectableCss;
    filterHeaderWidgetContainer?: InjectableCss;
    filtersContainer?: InjectableCss;
    tagsContainer?: InjectableCss;
    topPaginationContainer?: InjectableCss;
    tableContainer?: InjectableCss;
    bottomPaginationContainer?: InjectableCss;
}

export const myAccountListPagesLayoutStyles: MyAccountListPagesLayoutStyles = {};

const styles = myAccountListPagesLayoutStyles;
const MyAccountListPagesLayout: FC<WidgetProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="My-Account-History-Pages-Layout">
            <StyledWrapper {...styles.titleContainer}>
                <XngZone contentId={id} zoneName="Content01" hint="Zone For Title" />
            </StyledWrapper>
            <StyledWrapper {...styles.filterHeaderWidgetContainer}>
                <XngZone contentId={id} zoneName="Content02" hint="Zone For Filters Header" />
            </StyledWrapper>
            <StyledWrapper {...styles.filtersContainer}>
                <XngZone contentId={id} zoneName="Content03" hint="Zone For Filters" />
            </StyledWrapper>
            <StyledWrapper {...styles.tagsContainer}>
                <XngZone contentId={id} zoneName="Content04" hint="Zone For Tags" />
            </StyledWrapper>
            <StyledWrapper {...styles.tableContainer}>
                <XngZone contentId={id} zoneName="Content05" hint="Zone For Table" />
            </StyledWrapper>
            <StyledWrapper {...styles.bottomPaginationContainer}>
                <XngZone contentId={id} zoneName="Content06" hint="Zone For Bottom Pagination" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: MyAccountListPagesLayout,
    definition: {
        group: "Layout" as any,
        displayName: "My Account List Pages Layout",
        allowedContexts: [
            "OrderHistoryPage",
            "VmiOrderHistoryPage",
            "SavedOrderListPage",
            "OrderApprovalListPage",
            "RfqMyQuotesPage",
            "InvoiceHistoryPage",
            "PreviouslyPurchasedPage"
        ],
    },
};

export default widgetModule;
